import {
  Checkbox,
  Typography,
} from "@visma-netvisor/react-component-library";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { useServiceNeedContext } from "../../../context/ServiceNeedContext";
import LabeledOption from "../../LabeledOption";

const labeledOptionConfigs = [
  {
    name: "accountingServiceNeed",
    labelKey: "OnlineStatus.PossiblyYesShareContactToAccounting",
    setter: (context: ReturnType<typeof useServiceNeedContext>) => context.setAccountingServiceNeed
  },
  {
    name: "holviServiceNeed",
    labelKey: "OnlineStatus.PossiblyYesShareContactToHolvi",
    setter: (context: ReturnType<typeof useServiceNeedContext>) => context.setHolviServiceNeed
  },
];

const HolviServiceNeedPage = () => {
  const context = useServiceNeedContext();
  const { t } = useTranslation();

  const clearBoth = () => {
    context.setAccountingServiceNeed(false);
    context.setHolviServiceNeed(false);
  }

  return (
    <>
      <StyledTypography
        as="h3"
        color="secondary"
        variant="headingH4Regular"
        styleOverrides={{ paddingTop: 20, paddingBottom: 10 }}
      >
        {t("OnlineStatus.NeedMultipleServices")}
      </StyledTypography>
      {labeledOptionConfigs.map(({ name, labelKey, setter }, index) => (
        <LabeledOption
          key={`${name}-${index}`}
          name={name}
          labelKey={labelKey}
          onChange={e => setter(context)(e.target.checked)}
          type="checkbox" 
        />
      ))}
      <Checkbox
        label={t("OnlineStatus.NotThisTimeThanks")}
        name="accountingServiceNeed"
        checked={
          context.accountingServiceNeed === false &&
          context.holviServiceNeed === false
        }
        onChange={clearBoth}
      />
    </>
  )
}

export default HolviServiceNeedPage;

const StyledTypography = styled(Typography)`
  @media (max-width: 768px) {
    font-size: 16px;
  }
`;